// 直接导入vuex-persist，打包的时候会有以下错误
// Unexpected token: name «MockStorage», expected: punc «;»
// import VuexPersistence from 'vuex-persist';

import VuexPersistence from "vuex-persist/dist/umd";
import { SET_USER, CLEAR_USER } from "../mutation-types";
export default {
  state: {
    loginInfo: {
      id: 0,
      name: "",
      jobNumber: "",
      mobile: "",
      roleName: "",
      roleId: "",
      permissionInfo: "",
      token: "",
    }
  },
  getters: {
    roleId(state) {
      return state.loginInfo.roleId;
    },
    jobNumber(state) {
      return state.loginInfo.jobNumber;
    },
    mobile(state) {
      return state.loginInfo.mobile;
    },
    roleName(state) {
      return state.loginInfo.roleName;
    },
    adminName(state) {
      return state.loginInfo.name;
    },
    permissionInfo(state) {
      return state.loginInfo.permissionInfo;
    },
    /**
     * 判断是否超级管理员
     *
     * @param {*} state
     */
    isSuper(state) {
      return state.loginInfo.permissionInfo == 0;
    },
    isLogin(state) {
      return state.loginInfo.token && state.loginInfo.token.length > 0;
    },
    getLoginInfo(state) {
      return state.loginInfo;
    },
    getToken(state) {
      let loginInfo = state.loginInfo;
      if (loginInfo && loginInfo.token) {
        return loginInfo.token;
      }
      return "";
    },
    /**
     * 判断userId是否当前登录账号
     *
     * @param {*} state
     * @param {*} userId
     */
    isLoginUser: (state) => (userId) => {
      let loginInfo = state.loginInfo;
      if (loginInfo && loginInfo.id) {
        return loginInfo.id == userId;
      }
      return false;
    }
  },
  mutations: {
    /**
     * 保存登录信息
     * @param {*} state
     * @param {*} loginInfo
     */
    [SET_USER](state, loginInfo) {
      state.loginInfo.name = loginInfo.name;
      state.loginInfo.mobile = loginInfo.mobile;
      state.loginInfo.jobNumber = loginInfo.jobNumber;
      state.loginInfo.roleName = loginInfo.roleName;
      state.loginInfo.roleId = loginInfo.roleId;
      state.loginInfo.permissionInfo = loginInfo.permissionInfo;
      state.loginInfo.token = loginInfo.token;
      state.loginInfo.id = loginInfo.id;
    },
    /**
     * 退出操作
     * @param {*} state
     */
    [CLEAR_USER](state) {
      state.loginInfo.name = "";
      state.loginInfo.mobile = "";
      state.loginInfo.jobNumber = "";
      state.loginInfo.roleName = "";
      state.loginInfo.roleId = "";
      state.loginInfo.token = "";
      state.loginInfo.permissionInfo = "";
      state.loginInfo.id = "";
    }
  },
  action: {
    // do nothing
  }
};

/**
 * 持久化配置
 */
export const userVuexPersistence = () => {
  return new VuexPersistence({
    key: "user", // 不能同其他modules同名，否则localStorage会相互覆盖
    storage: window.localStorage,
    modules: ["user"], // store.modules中的模块同名
    filter: mutation => {
      return mutation.type == SET_USER || mutation.type == CLEAR_USER;
    }
  });
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js